import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const ReviewsRankingsPage = lazy(() =>
  import('./routes/ReviewsRankingsPage').then((m) => ({ default: m.ReviewsRankingsPage })),
);
const MyReviewsPage = lazy(() =>
  import('./routes/MyReviewsPage').then((m) => ({ default: m.MyReviewsPage })),
);
const ReviewResponsesPage = lazy(() =>
  import('./routes/ReviewResponsesPage').then((m) => ({ default: m.ReviewResponsesPage })),
);
const ReviewAggregationPage = lazy(() =>
  import('./routes/ReviewAggregationPage').then((m) => ({ default: m.ReviewAggregationPage })),
);
const ReviewFormsPage = lazy(() =>
  import('./routes/ReviewFormsPage').then((m) => ({ default: m.ReviewFormsPage })),
);
const QuestionBuilderPage = lazy(() =>
  import('./routes/QuestionBuilderPage').then((m) => ({ default: m.QuestionBuilderPage })),
);
const WriteReviewRoute = lazy(() =>
  import('./routes/WriteReviewRoute').then((m) => ({ default: m.WriteReviewRoute })),
);

/**
 * The Reviews & Ratings screens, and the two that need no product.
 *
 * <p>**Listed inside the `<ProductRoute />` group in `app/router`.** Three of them
 * (`/app/reviews/responses`, `/app/reviews/aggregation`, `/account/review-forms`, and `/reviews`
 * itself) are registered in `app/navigation/screens.ts` against `reviews_rankings`, so the group
 * demands the product by placement. `/reviews/myreviews` and `/write-review` are not registered:
 * anybody signed in may review a brand and read their own reviews, which is what the endpoints
 * behind them allow, so the guard passes them through.
 */
export const reviewsRoutes: RouteObject[] = [
  { path: ROUTES.reviews, element: <ReviewsRankingsPage /> },
  { path: ROUTES.reviewsMine, element: <MyReviewsPage /> },
  { path: ROUTES.reviewsResponses, element: <ReviewResponsesPage /> },
  { path: ROUTES.reviewsAggregation, element: <ReviewAggregationPage /> },
  { path: ROUTES.reviewForms, element: <ReviewFormsPage /> },
  { path: ROUTES.writeReview, element: <WriteReviewRoute /> },
];

/**
 * Review Management, the platform operator's question builder.
 *
 * <p>Exported apart from {@link reviewsRoutes} because the router nests it under
 * `SuperAdminRoute`, which guards the group: a screen added here inherits it by where it is put.
 * It names no product, since the questions belong to no customer.
 */
export const reviewsPlatformRoutes: RouteObject[] = [
  { path: ROUTES.reviewQuestions, element: <QuestionBuilderPage /> },
];
